module.exports = "<div class=\"input-errors\" *ngIf=\"errors\">\n  <div class=\"input-error\" *ngFor=\"let error of errors\">{{error}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/form-input-error/form-input-error.component.html
// module id = ./src/app/shared/form-input-error/form-input-error.component.html
// module chunks = main